import axios from 'axios'
import helper from "../services/helper";
import getEnv from '../utils/env';

const baseURL = getEnv('VUE_APP_LIGHT_HOUSE_BASE_URL');
/***** for single axios instance ******/
const axiosAuthInstance = axios.create({
  baseURL,
  headers: {"Content-Type": "application/json"}
});

axiosAuthInstance.interceptors.response.use(response => {
  return response
}, (error) => {
  //helper.clearSession();
  return new Promise((resolve, reject) => {
    reject(error);
  });
});
export default axiosAuthInstance;




// WEBPACK FOOTER //
// ./src/repositories/axiosAuthClient.js